// Configuration + chargement Google AdSense.
// Tant que REACT_APP_ADSENSE_CLIENT est vide, les pubs restent SIMULÉES (repli mocké).

export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";
export const AD_SLOTS = {
  side: process.env.REACT_APP_ADSENSE_SLOT_SIDE || "",
  bottom: process.env.REACT_APP_ADSENSE_SLOT_BOTTOM || "",
};

export const adsConfigured = () => Boolean(ADSENSE_CLIENT);

let scriptLoaded = false;

export function loadAdSense(client) {
  if (scriptLoaded || !client || typeof document === "undefined") return;
  scriptLoaded = true;
  // Le script est déjà injecté dans <head> (index.html) : on évite un doublon.
  if (document.querySelector('script[src*="adsbygoogle.js"]')) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
  s.crossOrigin = "anonymous";
  document.head.appendChild(s);
}

export function pushAd() {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch (e) {
    /* AdSense pas encore prêt */
  }
}
